<app-navigation class="pcoded-navbar"
    [ngClass]="{'navbar-collapsed' : navCollapsed, 'theme-horizontal': this.flatConfig['layout'] === 'horizontal', 'mob-open' : navCollapsedMob}"
    (onNavMobCollapse)="navMobClick()"></app-navigation>
<app-nav-bar class="navbar pcoded-header navbar-expand-lg navbar-dark"
    (onNavCollapse)="this.navCollapsed = !this.navCollapsed;" (onNavHeaderMobCollapse)="navMobClick()"></app-nav-bar>
<div class="pcoded-main-container">
    <div class="pcoded-content"
        [ngClass]="{'container': this.flatConfig.layout === 'horizontal' && this.flatConfig.subLayout === 'horizontal-2'}">
        <!-- <marquee width="60%" direction="left" height="50px" ng-repeat="invoice_no in Invoices">
            {{invoice_no}}
        </marquee>
        <div class="message-alert">

            <marquee width="100%" height="100%" class="marquee">

                <a class="app-marquee" *ngFor="let text of Invoices; let i = index;">
                    {{i+1}}
                    Invoice Due in 15 days:-{{text.invoice_no}}
                </a>

            </marquee>

        </div> -->
        <!-- <div class="text-right">
                <ng-template #tipContent> Due in 15 Days Invoices!</ng-template>
                <button class="btn btn-primary mr-0" type="button" data-toggle="modal"
                (click)=" showInvoiceModal.show()" [ngbTooltip]="tipContent" > Due Invoices</button>
            </div>
            <app-ui-modal #showInvoiceModal [hideFooter]="true"  [dialogClass]="'modal-lg'">
            <div class="app-modal-header">
                15 Days Due Invoices

            </div>
            <div class="app-modal-body">

                <div class="table-responsive">
                    <table class="gr-color table-bordered table table-striped text-center">
                        <thead>
                            <tr>
                                <th>#</th>
                             
                                <th>Invoice No</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of Invoices | paginate: config; let i = index;">
                                <td>{{i+1}}</td>
                                <td>{{item.invoice_no}}</td>
                                <tr>
                            </tbody>
                            </table>
                            <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
                            <button type="button" class="btn btn-danger  text-right" data-dismiss="modal"
                            (click)="showInvoiceModal.hide()">Close</button>
               
                        </div>
                </div>
 
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal"
                        (click)="showInvoiceModal.hide()">Close</button>
                  
                </div>

                </app-ui-modal> -->
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
    </div>
</div>
<app-configuration></app-configuration>